<template>
    <div class="message">
        <div
            :class="[
                'message-header',
                'flex',
                'flex-vertical-center',
                { 'flex-row-reverse': layout === 'right' }
            ]"
        >
            <img v-if="showAvatar" :src="avatar || defaultAvatar" class="user-avatar" />
            <span class="user-nick">{{ nickName }}</span>
        </div>
        <div class="message-body">
            {{ no ? `Q${no}： ` : '' }}{{ content }}
            <div v-if="answers.length">
                <div v-for="(answer, index) in answers" :key="index" class="answer">
                    <div class="answer-author">{{ answer.userName }}：</div>

                    <div class="answer-body">{{ answer.content }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import defaultAvatar from '@images/base/avatar.png';
export default {
    name: 'Message',
    props: {
        no: {
            type: Number
        },
        showAvatar: {
            type: Boolean,
            default: true
        },
        avatar: {
            type: String,
            default: defaultAvatar
        },
        nickName: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        layout: {
            type: String,
            validator: (val) => ['left', 'right'].includes(val),
            default: 'left'
        },
        answers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            defaultAvatar
        };
    }
};
</script>

<style lang="scss" scoped>
.message {
    color: #999798;
    &-header {
        margin-bottom: 7px;
    }
    &-body {
        background: #2b2b2d;
        border-radius: 10px;
        padding: 20px 11px;
        line-height: 1.8;
        white-space: pre-line;
    }
}
.user-avatar {
    width: 26px;
    height: 26px;
    border-radius: 26px;
    overflow: hidden;
    background-color: #ffffff;
}
.user-nick {
    margin-left: 6px;
    margin-right: 6px;
}
.answer {
    background: #333333;
    border-radius: 10px;
    padding: 10px 11px;
    line-height: 1.8;
    white-space: pre-line;
    margin-top: 10px;
    &-author {
        color: #3080cf;
    }
}
</style>
